export default "__VITE_ASSET__D_5JW42M__"